import FullImageHeroComponent, {
  Heading as HeadingType,
  Image as ImageType,
} from './FullImageHeroComponent'
export default FullImageHeroComponent
export type { HeadingType, ImageType }
